import type { ComponentsOverrides, Theme } from '@mui/material'

const styleOverrides: ComponentsOverrides<Theme>['MuiFormControl'] = {
  root: {
    '&.Mui-disabled': {
      opacity: 0.5,
    },
  },
}
const MuiFormControl = {
  styleOverrides,
}

export default MuiFormControl
